// process.env.VUE_APP_VERSION = require('../../package.json').version;

export default {
  GOOGLE_MAP_API_KEY: process.env.VUE_APP_GOOGLE_MAP_API_KEY
};
